import { flow } from 'fp-ts/function';
import { map, size, uniq } from 'lodash/fp';
import { BillState, OrderItemExtent } from '@mews-commander/data-access';
import { CommanderThunkAction } from '@mews-commander/types';
import { lt, showSuccessAlert } from '@mews/framework';
import { createFetchAction, mapId } from '@mews-commander/utils';
import { setProfiles } from '@mews-commander/legacy-entities/src/ducks/profiles';
import {
    setOrderItems,
    cancelOrderItems as cancelOrderItemsAction,
} from '@mews-commander/legacy-entities/src/ducks/orderItems';
import { filterRealBillIds, getBillsOwnerIds } from '@mews-commander/legacy-entities/src/ducks/bills';
import {
    DEFAULT_BILL_FETCH_EXTENT,
    fetchCurrentEnterpriseBillsByIds,
} from '@mews-commander/legacy-entities/src/actions/bills';
import { deselectAll, getCancelableItems } from '../ducks/billItems';
import { prefix } from '../module';
import { logBillingAction } from '../utils/logBillingAction';

const mapUniqueBillIds = flow(map('billId'), uniq);
const FETCH_ORDER_ITEMS = prefix('FETCH_ORDER_ITEMS');

interface FetchOrderItemsProps {
    orderItemIds: string[];
    extent?: OrderItemExtent;
}

export const fetchOrderItems =
    ({ orderItemIds, extent }: FetchOrderItemsProps): CommanderThunkAction =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.orderItems
            .getAll({
                orderItemIds,
                extent,
            })
            .then(({ orderItems, profiles }) => {
                if (profiles) dispatch(setProfiles(profiles));
                // @ts-expect-error
                dispatch(setOrderItems(orderItems));
            });

        return dispatch(createFetchAction(FETCH_ORDER_ITEMS, promise));
    };

export const cancelOrderItems = (scope: $TSFixMe) => async (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const state = getState();

    const orderItems = getCancelableItems(state, { scope });
    const orderItemIds = mapId(orderItems);

    const allBillIds = mapUniqueBillIds(orderItems);
    const billIds = filterRealBillIds(state, { ids: allBillIds });
    const accountIds = getBillsOwnerIds(state, { ids: allBillIds });

    await dispatch(cancelOrderItemsAction(orderItemIds));
    await dispatch(deselectAll(scope));
    await dispatch(
        fetchCurrentEnterpriseBillsByIds({
            accountIds,
            billIds,
            extent: { ...DEFAULT_BILL_FETCH_EXTENT, orderItems: true },
            state: BillState.Open,
        })
    );
    showSuccessAlert({ description: lt('SaveSuccessMessage') });
    await dispatch(
        logBillingAction('Order items canceled', { itemCount: size(orderItemIds), billCount: size(billIds) })
    );
};
